import { render } from "./LoadingOrderDetail.vue?vue&type=template&id=e8bebb0a"
import script from "./LoadingOrderDetail.vue?vue&type=script&lang=js"
export * from "./LoadingOrderDetail.vue?vue&type=script&lang=js"

import "./LoadingOrderDetail.vue?vue&type=style&index=0&id=e8bebb0a&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__